<dropdown-school class="noprint"></dropdown-school>
<dropdown-classroom class="noprint"></dropdown-classroom>
<!-- <app-phase-select class="noprint"></app-phase-select> -->

<div class="col-12 mt-1 p-1 justify-content-center d-flex d-md-none">
	<div class="mb-2 mt-2 col-2"></div>
	<button class="btn btn-lg btn-primary start mb-2 mt-2 gt-button col-8 noprint" style="border-color: #555555;" (click)="goToMainDash()">Record Scores</button>
	<div class="mb-2 mt-2 col-2"></div>
</div>

<div class="col-12 mt-1 p-1">
	<div class="card  h-100">
		<app-progress-table-accordion></app-progress-table-accordion>

			<div class="d-flex justify-content-center">
				<button class="btn btn-lg btn-primary start mb-2 mt-2 gt-button col-md-4 noprint" style="border-color: #555555;" (click)="goToMainDash()">Record Scores</button>
			</div>

	</div>
	<div class="card  h-100">
		<app-number-of-students-per-challenge [node]="selectedClassroom" ></app-number-of-students-per-challenge>
	</div>
		<div class="card  h-100">
			<export-data-card [node]="this?.selectedClassroom"></export-data-card>
		</div>
</div>
